import type { WithActiveBranchId } from '@app/api/shared';

export enum SupportEndpoints {
  GetSupportMessages = 'GetSupportMessages',
  SendMessageToSupport = 'SendMessageToSupport',
  GetSupportMessageFile = 'GetSupportMessageFile',
}

/**
 * Направление сообщения:
 * in — от пользователя в поддержку, out — от поддержки пользователю.
 */
export enum SupportMessageDirection {
  In = 'in',
  Out = 'out',
}

export interface ModelSupportParticipant {
  /** ID участника (для сопоставления с сообщениями) */
  ParticipantId?: string | null;
  NameFirst?: string | null;
  NameLast?: string | null;
  NameMiddle?: string | null;
  /** Аватар PNG в base64 */
  Avatar?: string | null;
}

/** Вложение сообщения (без содержимого) */
export interface ModelSupportMessageFile {
  Id: number;
  /** Имя файла с расширением */
  Name?: string | null;
  Extension?: string | null;
  /** Размер в байтах */
  Size?: number | null;
}

/** Файл с содержимым из GetSupportMessageFile */
export interface ModelSupportFile {
  Id: number;
  /** Имя файла с расширением */
  Name?: string | null;
  /** Содержимое файла в base64 */
  Data?: string | null;
  Lifetime?: string | null;
  Description?: string | null;
}

export interface ModelSupportMessage {
  Id: number;
  ParticipantId?: string | null;
  /** Время в часовой зоне пользователя */
  Timestamp: string;
  Message?: string | null;
  Direction?: SupportMessageDirection | null;
  Files?: ModelSupportMessageFile[] | null;
}

export interface ModelSupportChat {
  Participants?: ModelSupportParticipant[] | null;
  Messages?: ModelSupportMessage[] | null;
  /** Общее кол-во сообщений в переписке */
  TotalMessages: number;
}

export interface ModelSupportAttachment {
  /** Имя файла с расширением */
  Name: string;
  /** Содержимое файла в base64 */
  Data: string;
}

export interface ModelMessageToSupport {
  Message?: string | null;
  Attachments?: ModelSupportAttachment[] | null;
}

export type GetSupportMessagesRequest = WithActiveBranchId<{
  countMessages: number;
}>;

export type GetSupportMessagesResponse = ModelSupportChat;

export type SendMessageToSupportRequest = WithActiveBranchId<{
  data: ModelMessageToSupport;
}>;

export type SendMessageToSupportResponse = void;

export type GetSupportMessageFileRequest = WithActiveBranchId<{
  fileId: number;
}>;

export type GetSupportMessageFileResponse = ModelSupportFile;
